export enum ActiveLinkType {
  SequenceEntry = 'sequenceEntry',
  ConfirmOrder = 'confirmOrder',
  SpecificationsAndShipping = 'SpecificationsAndShipping',
  ReviewPage = 'reviewPage',
  MultipleEntry = 'multipleEntry',
}
export enum AmountValues {
  _2OD = '2 OD',
  _5OD = '5 OD',
}
export enum PurificationValues {
  desalt = 'DESALT',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  DuplexSheetName = 'siRNA Duplex',
  miRNADuplex = 'miRNA Duplex',
  FastDuplexSheetName = 'FAST siRNA Duplex',
  invalidFormatMsg = 'Invalid format. Please check the template and try again.',
  acceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
}
export enum BiTubeProduct {
  Duplex = 'duplex',
  FastDuplex = 'fastduplex',
  LightCycler = 'lightcycle',
  LightCyclerOld = 'lightcycle-old',
  BiTube = 'bitube',
  mirna = 'mirna',
}

export enum ReviewButtons {
  AddDuplex = 'Add Duplex',
  PrevPage = 'Previous Page',
  Continue = 'Continue',
}

export enum BitubeProperties {
  Quote = 'QUOTE',
  LoggedInUser = 'LoggedInUser',
  CustomerOverHang = 'customerOverhang',
  CustomerAntisenseOverHang = 'customerAntisenseOverHang',
  None = '[None]',
  OverhangDefault = '[dT][dT]',
  ThreeMod = 'threeMod',
  FiveMod = 'fiveMod',
  AntisenceThreeMod = 'antisenceThreeMod',
  AntisenceFiveMod = 'antisenceFiveMod',
  RequiredField = 'Required Field',
  SequenceKey = 'sequence',
  AntiSequenceKey = 'antisencesequence',
  AntiSenseName = 'antisenceName',
  NameKey = 'name',
  OligoName = 'Oligo Name',
  Amount = 'amount',
  QuoteItem = 'Quote Item',
  Success = 'success',
  SEQUENCE_API_TIME = 1000,
  NewOligo = 'New Oligo',
  NewDuplex = 'New Duplex',
  NoneMod = 'None',
  ReviewError = 'ReviewError',
  Format = 'format',
  Concentration = 'concentration',
  Purification = 'purification',
  DRY = 'DRY',
  MaximumOligosAllowed = 96,
  LIQUID = 'LIQUID',
  MirnaFiveMod = 'fivemod',
  csr_Header = 'In Solution option will default to concentration of 100uM',
  FormatHeader = 'Format',
  FormatValues = '(Dry or Liquid)',
}

export enum ProductHeader {
  Duplex = 'Custom siRNA in Tubes',
  FastDuplex = 'FAST siRNA Duplex Oligos',
  Lightcycle1 = 'Light Cycler',
  Lightcycle2 = 'Probes',
  Mirna = 'Custom miRNA in Tubes',
}

export enum Buttons {
  NextStep = 'Next Step',
  ViewDuplex = 'View Duplex(es)',
  ViewOligo = 'View Oligo(s)',
}

export enum DefaultValue {
  Select = 'Select',
  ThreeModification = "3' Modification:",
  FiveModification = 'fiveMod',
  OverHang = 'overhang',
  Category = '',
  Base = 'base',
  AddBases = 'Add Bases',
  InternalModification = 'internalMod',
  AddInternalMod = 'Add Internal Modifications',
  AddFiveMod = "5' Modification",
  AntisenseFiveMod = 'antiSenseFiveMod',
  AntisenseThreeMod = 'antiSenseThreeMod',
  SenseThreeMod = 'senseThreeMod',
  sequencePreview = 'Start typing sequence above to see the preview.',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}

export enum UploadType {
  copyPaste = 'copyPaste',
  fileUpload = 'fileUpload',
  prodType = 'tube',
}
